import { gql } from '@apollo/client';

export const UPDATE_FACILITY = gql`
    mutation updateFacility($facilityId: Guid!, $patch: UpdateFacilityPatch!) {
        company {
            facility {
                update(id: $facilityId, input: $patch)
            }
        }
    }
`;
